import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import {
  getAllOperatorUsers,
  getOperatorUser,
  getRoles,
  getAgencies,
} from "./utils";

const OperatorUsersContext = createContext();

export const OperatorUsersProvider = ({ children }) => {
  const [operatorUsers, setOperatorUsers] = useState(null);
  const [operatorUser, setOperatorUser] = useState();
  const [selectedOperatorUser, setSelectedOperatorUser] = useState(null);
  const [reload, setReload] = useState(true);
  const [roles, setRoles] = useState(null);
  const [selectedRoleBtn, setSelectedRoleBtn] = useState(false);
  const [agencies, setAgencies] = useState(null);
  const [selectedAgencyBtn, setSelectedAgencyBtn] = useState(false);
  const [authenticationChecked, setAuthenticationChecked] = useState("Success");

  const loadOperatorUsers = useCallback(() => {
    getAllOperatorUsers(setOperatorUsers, setAuthenticationChecked);
    getRoles(setRoles);
  });

  useEffect(() => {
    loadOperatorUsers();
    getAgencies(setAgencies);
    setReload(false);
  }, [reload]);

  useEffect(() => {
    if (selectedOperatorUser !== null && selectedOperatorUser.id !== null) {
      getOperatorUser(selectedOperatorUser.id, setOperatorUser);
      // getRoles(setRoles)
      getAgencies(setAgencies);
    }
  }, [selectedOperatorUser]);
  return (
    <OperatorUsersContext.Provider
      value={{
        operatorUsers,
        operatorUser,
        selectedOperatorUser,
        setOperatorUsers,
        setOperatorUser,
        setSelectedOperatorUser,
        setReload,
        roles,
        setRoles,
        selectedRoleBtn,
        setSelectedRoleBtn,
        agencies,
        setAgencies,
        selectedAgencyBtn,
        setSelectedAgencyBtn,
        authenticationChecked,
        setAuthenticationChecked,
      }}
    >
      {children}
    </OperatorUsersContext.Provider>
  );
};

export const useOperatorUsers = () => {
  const context = useContext(OperatorUsersContext);
  if (!context) {
    throw new Error(
      "useOperatorUsers must be used with in a OperatorUsersProvider",
    );
  }
  return context;
};
